import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { TemperatureInspectionListVM } from '../../../Temperature/temperature-inspection.module';
import { TranslateService } from '../../../../translate';
import { TemperatureInspectionService } from '../../../Temperature/temperature-inspection.service';
import { AppService } from '../../../../app.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AddTempInspectionDetailsCommentComponent } from '../../../Temperature/add-temp-inspection-details-comment/add-temp-inspection-details-comment.component';
import { MatDialog } from '@angular/material/dialog';import { AddTemInspectionCommentComponent } from '../../../Temperature/add-tem-inspection-comment/add-tem-inspection-comment.component';
import { ViewPhotoComponent } from '../view-photo/view-photo.component';

@Component({
  selector: 'app-temperature-inspection',
  templateUrl: './temperature-inspection.component.html',
  styleUrls: ['./temperature-inspection.component.scss']
})
export class TemperatureInspectionComponent implements OnInit {

  @Input() TemperatureInspectionList: TemperatureInspectionListVM[];
  @Input() inspectionId:number;
  @Input() equipmentId:number;
  userLanguage = 'english';
  constructor(
    private _translate: TranslateService, private _ref: ChangeDetectorRef, 
    private  _temperatureService: TemperatureInspectionService,
    private _router: Router,private _appService: AppService,
    private _sanitizer: DomSanitizer,private _dialog: MatDialog,
) { }

  ngOnInit() {
    console.log("TemperatureInspectionList", this.TemperatureInspectionList)
  }
  GotoFullDetails(inspectionId:number){
    this._router.navigate(['tempinspection', this.equipmentId , inspectionId]);
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this._ref.detectChanges();
  }
  getImage_(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  HasImage(Id:number){
    return this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.InspectionImage;
  }
  HasComment(Id:number){
    return this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.Note;
  }
  HasWarning(Id:number){
    let leftW= this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.WarningL;
    let RightW= this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.WarningL;
    if((leftW !=null) || (RightW !=null)){
      return true;
    }else{
      return false
    }
  }
  HasDetailComment(Id:number,InspectionDetailId:number,Side:number){
    if(Side==1){
      let com;
      this.TemperatureInspectionList.map(x=>{
        if(x.InspectionSummary.InspectionID == Id){
           com = x.LeftInspectionDetails.find(y=>y.InspectionDetailId == InspectionDetailId)
        }
       })
  
       if(com.Comment !=null){
         return true;
       }
  
    }else{
      let com;
      this.TemperatureInspectionList.map(x=>{
        if(x.InspectionSummary.InspectionID == Id){
           com = x.RightInspectionDetails.find(y=>y.InspectionDetailId == InspectionDetailId)
        }
       })
  
       if(com.Comment !=null){
         return true;
       }
     
    }
   
  }

  getWarning(Id:number){
    let warningL;
    let warningR;
    this.TemperatureInspectionList.map(x=>{
        if(x.InspectionSummary.InspectionID == Id){
           warningL = x.InspectionSummary.WarningL;
           warningR  = x.InspectionSummary.WarningR;
        }
    })
    let WL ='';
    let Final = 'LEFT' + '<br/>' + warningL + '<br/>' + 'RIGHT' + warningR ;
    return Final;
  }
  
  IsMajor(outlier:boolean){
    if(outlier != true){
      return false
    }else{
      return true;
    }
  }
  
  IsMinor(outlier:boolean){
    if(outlier != false){
      return false
    }else{
      return true;
    }
  }
  getEval(val:boolean){
    if(val== true)
    return "major"
    if(val== false)
    return "minor"
    if(val== null)
    return "none"
  }

  CheckSelectedInspection(Id:number){
    if(Id==this.inspectionId){
      return true;
    }else{
      return false;
    }
  }


  //Open Inspection Comment
UpdateInspectionComment(InspectionId:number, comment:string, isedit:boolean){
  const newInspectionCommentDialog = this._dialog.open(AddTemInspectionCommentComponent, {
    panelClass: 'removeModalOverflow',
    data: {
        equipmentId: this.equipmentId,
        InspectionId:InspectionId,
        Inspcomment: comment,
        isedit:isedit
    },
    minWidth: 500
});

newInspectionCommentDialog.afterClosed().subscribe(result => {

    
});
}

UpdateInspectionDetailComment(InspectionDetailId:number, comment:string, isedit:boolean){
  const newInspectionDetailCommentDialog = this._dialog.open(AddTempInspectionDetailsCommentComponent, {
    panelClass: 'removeModalOverflow',
    data: {
        equipmentId: this.equipmentId,
        inspectionDetailID:InspectionDetailId,
        Inspcomment: comment,
        isedit:isedit
    },
    minWidth: 500
});

newInspectionDetailCommentDialog.afterClosed().subscribe(result => {

});
}

viewInspectionPhoto(temperatureInspectionId: number,temperatureInspectionPhoto:string, isedit:boolean) {
  const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    data: {
      temperatureInspectionId : temperatureInspectionId,
      temperatureInspectionPhoto:temperatureInspectionPhoto,
      isedit:isedit
    }
  });
  viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
    
  });
}
viewInspectionDetailPhoto(temperatureInspectionDetailId: number,temperatureInspectionDetailPhoto:string,isedit:boolean)
{
  const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    data: {
      temperatureInspectionDetailId : temperatureInspectionDetailId,
      temperatureInspectionDetailPhoto:temperatureInspectionDetailPhoto,
      isedit:isedit
    }
  });
  viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
    
  });
}

}
